import { Route } from '@angular/router';

import { BranchDetailComponent } from './pages/branch-detail/branch-detail.component';
import { BranchesListComponent } from './pages/branches-list/branches-list.component';
import { EnvironmentsComponent } from './pages/environments/environments.component';

export const appRoutes: Route[] = [
  { path: '', component: BranchesListComponent },
  { path: 'environments', component: EnvironmentsComponent },
  { path: ':dynamicId', component: BranchDetailComponent },
];
